import React, { useEffect, useRef, useState } from "react";
import { FaUserCircle, FaArrowLeft, FaHome, FaBell } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useNotifications } from "../context/NotificationContext";
import { getRoleHomePage } from "../utils/roleHome";

function Navbar() {

  const navigate = useNavigate();
  const { user, role: backendRole, logout } = useAuth();
  const { unreadCount } = useNotifications();

  const [showProfile, setShowProfile] = useState(false);
  const profileRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(e) {
      if (profileRef.current && !profileRef.current.contains(e.target)) {
        setShowProfile(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  const role = backendRole
    ? backendRole.charAt(0).toUpperCase() + backendRole.slice(1)
    : "";

  return (
    <div
      style={{
        background: "#2e7d32",
        color: "white",
        padding: "15px 25px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 250,
        right: 0,
        zIndex: 1000,
        height: "70px"
      }}
    >

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "15px"
        }}
      >

        <button
          onClick={() => navigate(-1)}
          title="Back"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            background: "rgba(255,255,255,0.15)",
            color: "white",
            border: "none",
            borderRadius: "8px",
            padding: "8px 12px",
            cursor: "pointer",
            fontWeight: "600"
          }}
        >
          <FaArrowLeft /> Back
        </button>

        <button
          onClick={() => navigate(getRoleHomePage(backendRole))}
          title="Home"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            background: "rgba(255,255,255,0.15)",
            color: "white",
            border: "none",
            borderRadius: "8px",
            padding: "8px 12px",
            cursor: "pointer",
            fontWeight: "600"
          }}
        >
          <FaHome /> Home
        </button>

        <h2
          onClick={() => navigate(getRoleHomePage(backendRole))}
          style={{ margin: 0, cursor: "pointer" }}
        >
          🌿 Jain Farms
        </h2>
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px"
        }}
      >
        {backendRole?.toLowerCase() === "customer" && (
          <button
            onClick={() => navigate("/messages")}
            title="Messages"
            style={{
              position: "relative",
              background: "rgba(255,255,255,0.15)",
              border: "none",
              color: "white",
              borderRadius: "8px",
              padding: "10px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
            }}
          >
            <FaBell size={18} />
            {unreadCount > 0 && (
              <span
                style={{
                  position: "absolute", top: "-4px", right: "-4px",
                  background: "#dc2626", color: "white", borderRadius: "9px",
                  fontSize: "10px", fontWeight: 700, minWidth: "18px", height: "18px",
                  display: "flex", alignItems: "center", justifyContent: "center", padding: "0 4px",
                }}
              >
                {unreadCount > 99 ? "99+" : unreadCount}
              </span>
            )}
          </button>
        )}

        <div
          ref={profileRef}
          style={{ position: "relative" }}
        >
          <button
            onClick={() => setShowProfile((prev) => !prev)}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              background: "transparent",
              border: "none",
              color: "white",
              cursor: "pointer",
              padding: "4px"
            }}
          >
            <FaUserCircle size={30} />
            <span style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", lineHeight: "1.2" }}>
              <span style={{ fontSize: "14px", fontWeight: 600, whiteSpace: "nowrap" }}>
                {user?.full_name || role || "—"}
              </span>
              {role && (
                <span style={{ fontSize: "11px", color: "rgba(255,255,255,0.75)", whiteSpace: "nowrap" }}>
                  {role}
                </span>
              )}
            </span>
          </button>

          {showProfile && (
            <div
              style={{
                position: "absolute",
                top: "calc(100% + 10px)",
                right: 0,
                background: "white",
                color: "#333",
                borderRadius: "10px",
                boxShadow: "0 8px 25px rgba(0,0,0,0.25)",
                padding: "18px",
                width: "260px",
                zIndex: 1100
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "12px" }}>
                <FaUserCircle size={40} color="#2e7d32" />
                <div>
                  <div style={{ fontWeight: 700 }}>
                    {user?.full_name || "—"}
                  </div>
                  <div style={{ fontSize: "13px", color: "#2e7d32", fontWeight: 600 }}>
                    {role}
                  </div>
                </div>
              </div>

              <div style={{ fontSize: "14px", lineHeight: "1.8" }}>
                <div><strong>Mobile:</strong> {user?.mobile || "—"}</div>
                <div><strong>Email:</strong> {user?.email || "—"}</div>
                {user?.referral_code && (
                  <div><strong>Referral Code:</strong> {user.referral_code}</div>
                )}
              </div>
            </div>
          )}
        </div>

        <button
    onClick={handleLogout}
    style={{
      background: "#dc2626",
      color: "white",
      border: "none",
      padding: "8px 15px",
      borderRadius: "8px",
      cursor: "pointer",
      fontWeight: "600"
    }}
  >
    Logout
  </button>
      </div>

    </div>

  );
}

export default Navbar;